import request from '@/axios/http'

// 获取期号
export function queryNumber (type) {
	return request({
		url: '/stage-api/lottery/consult/queryColorfulSeedMaxByType/' + type,
		method: 'get',
	})
}
// 编辑用户信息
export function editCurrentUser (data) {
	return request({
		url: '/stage-api/system/user/editCurrentUser',
		data,
		method: 'put',
	})
}


// 获取当前用户查询新消息（收件箱）
export function queryCurrentUserMessage () {
	return request({
		url: '/stage-api/notify/preOffMail/queryCurrentUserMessage',
		method: 'get',
	})
}

// 缩水师预测
export function savePreRecordInfo (data) {
	return request({
		url: '/stage-api/pre/record/savePreRecordInfo',
		method: 'post',
		data
	})
}

// 缩水师预测明细
export function yucemingxi_detailList (params) {
	return request({
		url: '/stage-api/pre/detail/list',
		method: 'get',
		params
	})
}

// 帮扶中心实战超市
export function schemelist (params) {
	return request({
		// url: '/stage-api/assist/market/scheme/list',
		url: '/stage-api/assist/market/list',
		method: 'get',
		params
	})
}


// 查询当前用户所有彩种申请的进度
export function queryLotteryStatus (params) {
	return request({
		url: '/stage-api/cms/identity/infoList',
		method: 'get',
		params
	})
}


// 收入统计
export function incomeRecord (params) {
	return request({
		url: '/stage-api/recharge/income-record',
		method: 'get',
		params
	})
}

// 帮扶实战超市大厅获取团队信息
export function GetLotteryTeam (params) {
	return request({
		url: '/stage-api/assist/market/GetLotteryTeam',
		method: 'get',
		params
	})
}

// 帮扶实战超市大厅根据获取团队名称获取实战团队盈亏战绩
export function GetLotteryList (params) {
	return request({
		url: '/stage-api/assist/market/GetLotteryList',
		method: 'get',
		params
	})
}


// 系统消息
export function logininfor (params) {
	return request({
		url: '/stage-api/notify/preOffMail/queryCurrentUserSystemMessage',
		method: 'get',
		params
	})
}